import { Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { BasicHttpClientService } from 'app/shared/services/basic-http-client.service';
import { LoaderService } from 'app/shared/services/loader.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  @Input() public loaderId: string;
  @Input() public fullPage: boolean;

  public inLoading: boolean = false;
  public withContent: boolean;

  private subscription = new Subscription();

  constructor(
    private loaderService: LoaderService,
    private basicHttpClientService: BasicHttpClientService
  ) { }

  public ngOnInit() {
    if (this.loaderId) {
      this.subscription = this.loaderService.createLoader(this.loaderId).pipe(filter(x => !!x)).subscribe(data => {
        this.inLoading = data.show;
        const el = document.getElementById(this.loaderId);
        this.withContent = data.show && !!el && !!el.nextElementSibling;
      });
    }
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
    this.loaderService.destroyLoader(this.loaderId);
    this.basicHttpClientService.destroyLoader(this.loaderId);
  }
}
